var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-field panel-field-name" }, [
    _c(
      "div",
      { staticClass: "panel-field-option" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.editfield.first_name.show_field,
              callback: function($$v) {
                _vm.$set(_vm.editfield.first_name, "show_field", $$v)
              },
              expression: "editfield.first_name.show_field"
            }
          },
          [_vm._v(" First Name ")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-caret-down panel-right",
          on: { click: _vm.toggleNameFieldInputs }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name-option__settings" }, [
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("First Name Label"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.first_name.label,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.first_name, "label", $$v)
                  },
                  expression: "editfield.first_name.label"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-field-first_name contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("First Name Placeholder"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.first_name.placeholder,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.first_name, "placeholder", $$v)
                  },
                  expression: "editfield.first_name.placeholder"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("First Name Default Value"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.first_name.default,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.first_name, "default", $$v)
                  },
                  expression: "editfield.first_name.default"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Required"))
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.editfield.first_name.required,
                    callback: function($$v) {
                      _vm.$set(_vm.editfield.first_name, "required", $$v)
                    },
                    expression: "editfield.first_name.required"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v(" Yes ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [_vm._v(" No ")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.editfield.first_name.required == true
            ? _c(
                "div",
                [
                  _c("label", { staticClass: "contactum-label" }, [
                    _vm._v(" Error Message: ")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    model: {
                      value: _vm.editfield.first_name.message,
                      callback: function($$v) {
                        _vm.$set(_vm.editfield.first_name, "message", $$v)
                      },
                      expression: "editfield.first_name.message"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel-field-option" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.editfield.middle_name.show_field,
              callback: function($$v) {
                _vm.$set(_vm.editfield.middle_name, "show_field", $$v)
              },
              expression: "editfield.middle_name.show_field"
            }
          },
          [_vm._v(" Middle Name ")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-caret-down panel-right",
          on: { click: _vm.toggleNameFieldInputs }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name-option__settings" }, [
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Middle Name Label"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.middle_name.label,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.middle_name, "label", $$v)
                  },
                  expression: "editfield.middle_name.label"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-field-middle_name contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Middle Name Placeholder"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.middle_name.placeholder,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.middle_name, "placeholder", $$v)
                  },
                  expression: "editfield.middle_name.placeholder"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Middle Name Default Value"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.middle_name.default,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.middle_name, "default", $$v)
                  },
                  expression: "editfield.middle_name.default"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Required"))
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.editfield.middle_name.required,
                    callback: function($$v) {
                      _vm.$set(_vm.editfield.middle_name, "required", $$v)
                    },
                    expression: "editfield.middle_name.required"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v(" Yes ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [_vm._v(" No ")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.editfield.middle_name.required == true
            ? _c(
                "div",
                [
                  _c("label", { staticClass: "contactum-label" }, [
                    _vm._v(" Error Message: ")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    model: {
                      value: _vm.editfield.middle_name.message,
                      callback: function($$v) {
                        _vm.$set(_vm.editfield.middle_name, "message", $$v)
                      },
                      expression: "editfield.middle_name.message"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel-field-option" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.editfield.last_name.show_field,
              callback: function($$v) {
                _vm.$set(_vm.editfield.last_name, "show_field", $$v)
              },
              expression: "editfield.last_name.show_field"
            }
          },
          [_vm._v(" Last Name ")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-caret-down panel-right",
          on: { click: _vm.toggleNameFieldInputs }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name-option__settings" }, [
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Last Name Label"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.editfield.last_name.label,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.last_name, "label", $$v)
                  },
                  expression: "editfield.last_name.label"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-field-last_name contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Last Name Placeholder"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "text" },
                model: {
                  value: _vm.editfield.last_name.placeholder,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.last_name, "placeholder", $$v)
                  },
                  expression: "editfield.last_name.placeholder"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Last Name Default Value"))
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "text" },
                model: {
                  value: _vm.editfield.last_name.default,
                  callback: function($$v) {
                    _vm.$set(_vm.editfield.last_name, "default", $$v)
                  },
                  expression: "editfield.last_name.default"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum-label" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(_vm._s("Required"))
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.editfield.last_name.required,
                    callback: function($$v) {
                      _vm.$set(_vm.editfield.last_name, "required", $$v)
                    },
                    expression: "editfield.last_name.required"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v(" Yes ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [_vm._v(" No ")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.editfield.last_name.required == true
            ? _c(
                "div",
                [
                  _c("label", { staticClass: "contactum-label" }, [
                    _vm._v(" Error Message: ")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    model: {
                      value: _vm.editfield.last_name.message,
                      callback: function($$v) {
                        _vm.$set(_vm.editfield.last_name, "message", $$v)
                      },
                      expression: "editfield.last_name.message"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }